const apiUrl = process.env.REACT_APP_API_URL;

export const GetJutgeUsuariIdJavaballLogs = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${id}/javaball-logs`);
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('Error al obtener el historial de lanzamientos de Javaballs:', error);
        return [];
    }
};

